import styled from 'styled-components';
import Collapse from '@mui/material/Collapse';
import { Styling, Colors } from '../../../../constants';
import { DialogHeader } from '../../../Shared/styles/dialog';

export const FormRow = styled.div`
  display: flex;
  flex-flow: row wrap;
`;

export const DropContainer = styled.div`
  width: 100%;
  padding: ${Styling.DEFAULT_SPACING_DOUBLED}px;
`;

export const DropNotice = styled.h1`
  cursor: default;
  left: 0;
  right: 0;
  font-weight: bolder;
  font-size: 20px;
  text-transform: uppercase;
  text-align: center;
  color: ${Colors.MEDIUM_GREY};

  svg {
    position: relative;
    top: 4px;
  }
`;

export const UploadStatusBar = styled.span`
  color: ${Colors.MEDIUM_GREY};
`;

export const SelectedFileContainer = styled.div`
  width: 100%;
  align-items: center;
`;

export const UploadStatusText = styled.span`
  color: ${Colors.MEDIUM_GREY};
  padding-left: 8px;
`;

export const StyledCollapse = styled(Collapse)`
  overflow-y: auto;
  &.dropzone {
    width: calc(100% - 215px);
  }
`;

export const StyledExistingScheduleLabel = styled.span`
  padding: 10px;
  font-size: 14px;
  font-weight: 400;
  color: #da1717;
  margin-left: 14px;
`;

export const StyledExistingSchedule = styled.span`
  color: black;
`;

export const StyledUploadMessage = styled.span`
  padding-left: 10px;
  padding-top: 10px;
`;

export const StyledDialogHeader = styled(DialogHeader)`
  justify-content: space-between;
  padding-right: 0;
  .title {
    max-width: 215px;
    height: 22px;
  }
`;
